// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { styles } from "@bg/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { productQuantityOrderedStyles } from "@bgs/Overrides/Components/ProductQuantityOrdered";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.dragHandleIcon = {
    src: "Drag",
    color: "text.main",
    size: 17,
    css: css`
        cursor: move;
        opacity: 0.7;
        @media (max-width: 1025px) {
            display: none;
        }
    `,
};

styles.printQrCode = linkIconStyleGenerator({
    icon: "QrCode",
    textSize: "13px",
    iconSize: 15,
    additionalTypographyCss: css`
        opacity: 0.8;
        line-height: 16px;
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
});

styles.deleteLink = {
    css: css`
        &&& {
            min-width: auto;
            background: transparent;
            padding: 0;
            min-height: unset;
            svg {
                fill: ${getColor("tertiary")};
            }

            &:hover svg {
                fill: ${getColor("primary")};
            }
        }
    `,
};
styles.productQuantityOrderedStyles = {
    wrapper: {
        css: css`
            ${productQuantityOrderedStyles.wrapper?.css}
            &&& input {
                max-width: 100%;
                width: 100%;
            }
        `,
    },
    inputStyles: {
        ...productQuantityOrderedStyles.inputStyles,
    },
};

styles.productPriceStyles = {
    ...styles.productPriceStyles,
    price: {
        priceText: {
            size: 18,
            lineHeight: fontConfig.lineHeight.small,
            weight: fontConfig.weight.semiBold,
            css: css`
                white-space: nowrap;
            `,
        },
        unitOfMeasureText: {
            size: 18,
            lineHeight: fontConfig.lineHeight.small,
            weight: fontConfig.weight.semiBold,
            transform: "uppercase",
            css: css`
                white-space: nowrap;
            `,
        },
    },
};

styles.priceTotal = {
    size: 18,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.semiBold,
};

styles.quantityGridItem = {
    css: css`
        button:last-child {
            border-right: 2px solid ${getColor("text")} !important;
        }
    `,
};

styles.buttonsGridItem = {
    css: css`
        width: 210px;
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        &&.one-button {
            width: 150px;
            justify-content: flex-end;
        }
        && .default,
        && .loading {
            min-height: 32px;
            font-weight: ${fontConfig.weight.semiBold};
            min-width: 135px;
            @media (max-width: 500px) {
                min-width: 0px;
            }
            .atc-label {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: 16px;
            }
        }

        @media (max-width: 500px) {
            width: 100% !important;
            padding: 0;
            margin: 10px 0;
            align-items: center;
        }
    `,
};
